import { PermissionFieldProfile, PermissionOption } from "./types";

export const gateApiScopeOptions: PermissionOption[] = [
    { value: "auth.session", label: "Session", group: "Auth" },
    { value: "auth.login", label: "Login", group: "Auth" },
    { value: "auth.login.remember", label: "Remember Login", group: "Auth" },
    { value: "auth.login.remembered", label: "Remembered Login", group: "Auth" },
    { value: "auth.login_redirect", label: "Login Redirect", group: "Auth" },
    { value: "auth.logout", label: "Logout", group: "Auth" },
    { value: "router.navigate", label: "Navigate", group: "Router" },
    { value: "ui.notify", label: "Notify", group: "UI" },
    { value: "record.query", label: "Query", group: "Records" },
    { value: "record.get", label: "Get", group: "Records" },
    { value: "record.create", label: "Create", group: "Records" },
    { value: "record.update", label: "Update", group: "Records" },
    { value: "record.delete", label: "Delete", group: "Records" },
    { value: "email.send", label: "Send Email", group: "Email" },
    { value: "email.send_template", label: "Send Email Template", group: "Email" },
    { value: "email.render_template", label: "Render Email Template", group: "Email" },
    { value: "email.upload_attachment", label: "Upload Email Attachment", group: "Email" },
    { value: "email.delete_attachment", label: "Delete Email Attachment", group: "Email" },
    { value: "email.test_connection", label: "Test Email Connection", group: "Email" },
    { value: "attachment.list", label: "List Attachments", group: "Attachments" },
    { value: "attachment.upload", label: "Upload Attachment", group: "Attachments" },
    { value: "attachment.delete", label: "Delete Attachment", group: "Attachments" },
    { value: "attachment.download_url", label: "Attachment Download URL", group: "Attachments" },
    { value: "attachment.view_url", label: "Attachment View URL", group: "Attachments" },
    { value: "service_portal.submit", label: "Submit Portal Form", group: "Service Portal" },
    { value: "service_portal.reference.lookup", label: "Portal Reference Lookup", group: "Service Portal" },
    { value: "service_portal.request.public_get", label: "Get Public Portal Request", group: "Service Portal" },
    { value: "service_portal.attachment.list", label: "List Portal Draft Attachments", group: "Service Portal" },
    { value: "service_portal.attachment.upload", label: "Upload Portal Draft Attachment", group: "Service Portal" },
    { value: "service_portal.attachment.delete", label: "Delete Portal Draft Attachment", group: "Service Portal" },
    { value: "service_portal.attachment.download_url", label: "Portal Draft Attachment Download URL", group: "Service Portal" },
    { value: "service_portal.attachment.view_url", label: "Portal Draft Attachment View URL", group: "Service Portal" },
    { value: "session.user.create", label: "Create User", group: "Session User" },
    { value: "session.user.update", label: "Update User", group: "Session User" },
    { value: "session.user.password", label: "Update Password", group: "Session User" },
];

export const businessRuleSelfOptions: PermissionOption[] = [
    { value: "db.read:self", label: "Read Current Table", group: "Current Table" },
    { value: "db.write:self", label: "Write Current Table", group: "Current Table" },
    { value: "attachment.read:self", label: "Read Current Table Attachments", group: "Current Table" },
    { value: "attachment.write:self", label: "Write Current Table Attachments", group: "Current Table" },
];

export const platformJobOptions: PermissionOption[] = [
    { value: "http.call:*", label: "HTTP Any Host", group: "HTTP" },
    { value: "secret.read:*", label: "Read Secrets", group: "Secrets" },
    { value: "secret.write:*", label: "Write Secrets", group: "Secrets" },
];

export const emailRuntimeOptions: PermissionOption[] = [
    { value: "email.send", label: "Send Email", group: "Email" },
    { value: "email.send_template", label: "Send Email Template", group: "Email" },
    { value: "email.render_template", label: "Render Email Template", group: "Email" },
    { value: "email.test_connection", label: "Test Email Connection", group: "Email" },
];

export const attachmentRuntimeOptions: PermissionOption[] = [
    { value: "attachment.read:*", label: "Read Attachments", group: "Attachments" },
    { value: "attachment.write:*", label: "Write Attachments", group: "Attachments" },
];

export const permissionFieldProfiles: Record<string, PermissionFieldProfile> = {
    "gate.api_scope.page": {
        id: "gate.api_scope.page",
        kind: "gate_api_scope",
        label: "Gate Page API Scope",
        options: gateApiScopeOptions,
    },
    "gate.api_scope.widget": {
        id: "gate.api_scope.widget",
        kind: "gate_api_scope",
        label: "Gate Widget API Scope",
        options: gateApiScopeOptions,
    },
    "runtime.capabilities.business_rule": {
        id: "runtime.capabilities.business_rule",
        kind: "runtime_capabilities",
        label: "Business Rule Capabilities",
        options: [...businessRuleSelfOptions, ...emailRuntimeOptions, ...attachmentRuntimeOptions],
        allowSelfCapabilities: true,
        allowFlussDefinitions: true,
    },
    "runtime.capabilities.dynamic_api_script": {
        id: "runtime.capabilities.dynamic_api_script",
        kind: "runtime_capabilities",
        label: "Dynamic API Script Capabilities",
        options: [...emailRuntimeOptions, ...attachmentRuntimeOptions],
        allowWildcard: true,
    },
    "runtime.capabilities.platform_job": {
        id: "runtime.capabilities.platform_job",
        kind: "runtime_capabilities",
        label: "Platform Job Capabilities",
        options: [...platformJobOptions, ...emailRuntimeOptions, ...attachmentRuntimeOptions],
        allowWildcard: true,
    },
    "dynamic_api.endpoint_scope.freeform": {
        id: "dynamic_api.endpoint_scope.freeform",
        kind: "freeform_scope",
        label: "Dynamic API Endpoint Scope",
        options: [],
        allowWildcard: true,
    },
};
